/*application-packages*/
/*installing-an-application-package-into-another-package*/
/*library-packages*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "软件包类型",
  "description": "了解工作区中不同类型的包。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "在 Turborepo 中，我们讨论两种类型的包："
  }, {
    "heading": "",
    "content": "¥In Turborepo, we talk about two types of packages:"
  }, {
    "heading": "",
    "content": "应用包"
  }, {
    "heading": "",
    "content": "¥Application Packages"
  }, {
    "heading": "",
    "content": "库软件包"
  }, {
    "heading": "",
    "content": "¥Library Packages"
  }, {
    "heading": "应用包-application-packages",
    "content": "¥Application Packages"
  }, {
    "heading": "应用包-application-packages",
    "content": "应用包是你工作区中的一个包，它将从你的工作区部署。应用包的示例包括 Next.js、Svelte、Vite 或 CLI 应用，这些应用通常位于 ./apps 目录中。"
  }, {
    "heading": "应用包-application-packages",
    "content": "¥An Application Package is a package in your workspace that will be deployed from your workspace. Examples of Application Packages are Next.js, Svelte, Vite, or CLI applications that are commonly found in the ./apps directory."
  }, {
    "heading": "应用包-application-packages",
    "content": "最佳做法是，你的应用包是 软件包图表 的 \"end\"，而不会安装到存储库的其他包中。你的 CI/CD 流水线通常会在包图和任务图的这些节点处完成。"
  }, {
    "heading": "应用包-application-packages",
    "content": "¥It's best practice that your Application Packages are the \"end\" of your Package Graph, not being installed into other packages of your repository. Your CI/CD pipelines will most often finalize at these nodes of your Package and Task Graphs."
  }, {
    "heading": "将应用包安装到另一个包中-installing-an-application-package-into-another-package",
    "content": "¥Installing an application package into another package"
  }, {
    "heading": "将应用包安装到另一个包中-installing-an-application-package-into-another-package",
    "content": "在极少数情况下，你可能需要将应用包安装到另一个包中。这应该是例外。如果你发现经常这样做，你可能需要重新考虑你的包结构。"
  }, {
    "heading": "将应用包安装到另一个包中-installing-an-application-package-into-another-package",
    "content": "¥In rare cases, you may need to install an Application Package into another package. This should be the exception. If you find you are doing this often, you may want to rethink your package structure."
  }, {
    "heading": "将应用包安装到另一个包中-installing-an-application-package-into-another-package",
    "content": "此规则的一个例外示例是将你的应用包安装到处理端到端测试的包中。安装后，你可以在端到端测试包中依赖应用包，以便它能够感知应用的重新部署。"
  }, {
    "heading": "将应用包安装到另一个包中-installing-an-application-package-into-another-package",
    "content": "¥An example of an exception for this rule is installing your Application Package into a package that handles end-to-end testing. Once installed, you can depend on the Application Package in your end-to-end testing package so it is aware of re-deploys of the application."
  }, {
    "heading": "库软件包-library-packages",
    "content": "¥Library Packages"
  }, {
    "heading": "库软件包-library-packages",
    "content": "库包包含你打算在工作区内共享的代码。它们不能独立部署。相反，它们支持应用包，以便从你的代码库创建最终的可部署文件。你也可以将这些包称为 内部软件包，它们有自己的子类型。"
  }, {
    "heading": "库软件包-library-packages",
    "content": "¥Library Packages contain code that you intend to share around your workspace. They aren't independently deployable. Instead, they support the Application Packages to create the final deployables from your repository. You might also refer to these packages as Internal Packages, which have their own sub-types."
  }],
  "headings": [{
    "id": "应用包-application-packages",
    "content": "应用包 /*application-packages*/"
  }, {
    "id": "将应用包安装到另一个包中-installing-an-application-package-into-another-package",
    "content": "将应用包安装到另一个包中 /*installing-an-application-package-into-another-package*/"
  }, {
    "id": "库软件包-library-packages",
    "content": "库软件包 /*library-packages*/"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#应用包-application-packages",
  title: _jsx(_Fragment, {
    children: "应用包 "
  })
}, {
  depth: 3,
  url: "#将应用包安装到另一个包中-installing-an-application-package-into-another-package",
  title: _jsx(_Fragment, {
    children: "将应用包安装到另一个包中 "
  })
}, {
  depth: 2,
  url: "#库软件包-library-packages",
  title: _jsx(_Fragment, {
    children: "库软件包 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "在 Turborepo 中，我们讨论两种类型的包："
    }), "\n", _jsx(_components.p, {
      children: "¥In Turborepo, we talk about two types of packages:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#application-packages",
            children: "应用包"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#application-packages",
            children: "Application Packages"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#library-packages",
            children: "库软件包"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#library-packages",
            children: "Library Packages"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "应用包-application-packages",
      children: "应用包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Application Packages"
    }), "\n", _jsxs(_components.p, {
      children: ["应用包是你工作区中的一个包，它将从你的工作区部署。应用包的示例包括 Next.js、Svelte、Vite 或 CLI 应用，这些应用通常位于 ", _jsx(_components.code, {
        children: "./apps"
      }), " 目录中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥An Application Package is a package in your workspace that will be deployed from your workspace. Examples of Application Packages are Next.js, Svelte, Vite, or CLI applications that are commonly found in the ", _jsx(_components.code, {
        children: "./apps"
      }), " directory."]
    }), "\n", _jsxs(_components.p, {
      children: ["最佳做法是，你的应用包是 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "软件包图表"
      }), " 的 \"end\"，而不会安装到存储库的其他包中。你的 CI/CD 流水线通常会在包图和任务图的这些节点处完成。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥It's best practice that your Application Packages are the \"end\" of your ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), ", not being installed into other packages of your repository. Your CI/CD pipelines will most often finalize at these nodes of your Package and Task Graphs."]
    }), "\n", _jsx(_components.h3, {
      id: "将应用包安装到另一个包中-installing-an-application-package-into-another-package",
      children: "将应用包安装到另一个包中 "
    }), "\n", _jsx(_components.p, {
      children: "¥Installing an application package into another package"
    }), "\n", _jsx(_components.p, {
      children: "在极少数情况下，你可能需要将应用包安装到另一个包中。这应该是例外。如果你发现经常这样做，你可能需要重新考虑你的包结构。"
    }), "\n", _jsx(_components.p, {
      children: "¥In rare cases, you may need to install an Application Package into another package. This should be the exception. If you find you are doing this often, you may want to rethink your package structure."
    }), "\n", _jsx(_components.p, {
      children: "此规则的一个例外示例是将你的应用包安装到处理端到端测试的包中。安装后，你可以在端到端测试包中依赖应用包，以便它能够感知应用的重新部署。"
    }), "\n", _jsx(_components.p, {
      children: "¥An example of an exception for this rule is installing your Application Package into a package that handles end-to-end testing. Once installed, you can depend on the Application Package in your end-to-end testing package so it is aware of re-deploys of the application."
    }), "\n", _jsx(_components.h2, {
      id: "库软件包-library-packages",
      children: "库软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Library Packages"
    }), "\n", _jsxs(_components.p, {
      children: ["库包包含你打算在工作区内共享的代码。它们不能独立部署。相反，它们支持应用包，以便从你的代码库创建最终的可部署文件。你也可以将这些包称为 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "内部软件包"
      }), "，它们有自己的子类型。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Library Packages contain code that you intend to share around your workspace. They aren't independently deployable. Instead, they support the Application Packages to create the final deployables from your repository. You might also refer to these packages as ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "Internal Packages"
      }), ", which have their own sub-types."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
